import { FC, useEffect, useState } from 'react';
import { ordersList } from '../../apis';
import styled from './index.module.scss';
import * as AllComponent from '.';
import { headerLangText } from './elements/headerLang';
import HeaderLeft from './icon/HeaderLeft';
import HeaderRight from './icon/HeaderRight';
import { ListType, I18n } from './elements/AppData/I18n';
import { queryStatistics } from './elements/AppData/service';
import getLocal from '@/app/utils/getLocal';
import { getUserInfo } from '@/service/login';
import { message } from '@/components/UI/Message';

export type ComponentType =
    | 'UserInfo'
    | 'OrderInfo'
    | 'Recommended'
    | 'AnswerAward'
    | 'EcoBenefits'
    | 'ReferralInfo'
    | 'SummaryEnd'
    | 'EcoCreditsInfo'
    | 'AppData'
    | 'AppPrefix';

interface IProps {
    isModal?: boolean;
    callback?: any;
}

const siteList = [
    {
        locale: 'us',
    },
    {
        locale: 'ca',
    },
    {
        locale: 'jp',
    },
    {
        locale: 'au',
    },
    {
        locale: 'za',
    },
    {
        locale: 'kr',
    },
    {
        locale: 'uk',
    },
    {
        locale: 'eu',
    },
    {
        locale: 'de',
    },
    {
        locale: 'fr',
    },
    {
        locale: 'it',
    },
    {
        locale: 'es',
    },
];

// 判断用户是否是旧用户
const OLDUSERTIME = '2024/03/24 00:00:00 GMT+8';

const AnnualSummary: FC<IProps> = ({ isModal = false, callback }) => {
    const { locale } = getLocal();
    const [nav, setNav] = useState<ComponentType[]>([]);
    const [step, setStep] = useState(0);
    const [OldUser, setOldUser] = useState(false);
    const textA = headerLangText[locale] || headerLangText['us'];
    const [userInfoA, setuserInfoA] = useState<any>({});
    const [appData, setAppData] = useState((I18n[locale] || I18n.us) as ListType);

    const initData = async () => {
        const res = await getUserInfo(locale);

        if (res.code !== '0' || !res.data) return message.error(res.message);

        const isOld = new Date(res.data.createTime.replaceAll('-', '/')).getTime() <= new Date(OLDUSERTIME).getTime();

        setOldUser(isOld);
        setuserInfoA(res.data);

        // const noResult = await initAppData();
        // setNav(['AppData', 'EcoBenefits', 'UserInfo', 'OrderInfo', 'Recommended', 'AnswerAward', 'ReferralInfo', 'SummaryEnd', 'EcoCreditsInfo', 'AppData']);
        if (isModal) {
            if (isOld) {
                // 老用户 -> 用户信息 订单信息 积分信息 推荐场景选择 答题奖励 referral项目 是否查看app数据 结束页
                const arr: ComponentType[] = ['UserInfo', 'OrderInfo', 'EcoCreditsInfo', 'Recommended', 'AnswerAward', 'ReferralInfo', 'SummaryEnd'];
                // 没有订单跳过订单详情
                const noOrders = await ordersListFn();
                if (noOrders) arr.splice(1, 1);
                setNav(arr);
            } else {
                // 新用户 -> 用户信息 推荐场景选择 答题奖励 会员权益 referral项目
                setNav(['UserInfo', 'Recommended', 'AnswerAward', 'EcoBenefits', 'ReferralInfo']);
            }
        } else {
            const noResult = await initAppData();
            if (isOld) {
                // 链接打开老用户 -> 用户信息 app信息 推荐场景选择 答题奖励 会员权益 referral项目
                const arr: ComponentType[] = ['UserInfo', 'AppData', 'Recommended', 'AnswerAward', 'EcoBenefits', 'ReferralInfo'];
                // 如果没有数据就不展示appdata数据
                if (noResult) arr.splice(1, 1);
                setNav(arr);
            } else {
                // 链接打开新用户 -> 用户信息 推荐场景选择 答题奖励 会员权益 referral项目
                setNav(['UserInfo', 'Recommended', 'AnswerAward', 'EcoBenefits', 'ReferralInfo']);
            }
        }
    };

    const handleClose = () => {
        callback && callback('close');
    };

    const handleNext = () => {
        if (step >= nav.length - 1) {
            // 最后了
            handleClose();
            return;
        }
        setStep(step + 1);
    };

    const handleBack = () => {
        if (step <= 0) return;
        setStep(step - 1);
    };

    const calcStatistics = (data: any[], k: number, appTempData: ListType[]) => {
        let power = 0,
            appliances = '';
        data?.map((item: any, m: number) => {
            appliances += (m === 0 ? '' : ', ') + item?.indexName;
            power += item?.indexValue;
        });
        // 添加碳排放参数
        let carbon = '';
        const lbsLocale = ['us', 'ca', 'uk'];
        if (lbsLocale.includes(locale)) {
            carbon = `${((power * 86) / 100 / 1000).toFixed(2)}lbs`;
        } else {
            carbon = `${((power * 39) / 100 / 1000).toFixed(2)}kg`;
        }
        power += data[0]?.unit || '';
        appTempData[k] = {
            ...appTempData[k],
            power,
            appliances,
            title: appTempData[k].title.replaceAll(`[power]`, power).replaceAll('[appliances]', appliances),
            desc: appTempData[k].desc.replaceAll('[carbon]', carbon),
        };
    };

    const initAppData = async () => {
        const appTempData = JSON.parse(JSON.stringify(appData?.items) || '[]');
        const promises: any[] = [];
        const commonReq = async (code: any) => await queryStatistics({ code }, locale);
        appTempData?.map((item: ListType) => promises.push(commonReq(item.code)));
        const resultsArr = await Promise.all(promises);
        let noResult = true;
        resultsArr?.map((result: any, k: number) => {
            if (result?.data?.length > 0) {
                noResult = false;
                calcStatistics(result?.data, k, appTempData);
            }
        });
        setAppData(appTempData);
        return noResult;
    };

    // 购买记录
    const ordersListFn = async () => {
        const res = await ordersList(locale);
        if (res.code !== '0' || !res.data) return false;
        return res.data.orders?.length === 0;
    };

    useEffect(() => {
        initData();
    }, []);

    if (!nav[step]) return <></>;

    const Component = AllComponent[nav[step]];

    return (
        <div className={`${styled.AnnualSummary} ${isModal ? `${styled.winAnnua} winAnnua` : styled.appPage}`}>
            <div className="header">
                <HeaderLeft className="header-back" onClick={handleBack} />
                <div className="header-c">{textA['CommonTitle']}</div>
                <HeaderRight className="header-close" onClick={handleClose} />
            </div>
            <div className="annu-content">
                {/* <AppSiteSelect localeList={siteList} /> */}
                <Component handleNext={handleNext} isModal={isModal} OldUser={OldUser} userInfo={userInfoA} handleClose={handleClose} items={appData} />
            </div>
        </div>
    );
};

export default AnnualSummary;
